import React, { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  isRestaurantPathRedirectableToKiosk,
  mapRestaurantPathToKiosk,
  shouldRedirectRestaurantPathToKiosk,
} from './kioskPaths';

/**
 * Keeps kiosk devices on `/kiosk/...` when something links to `/restaurants/...`
 * (ongoing-order bar, notifications, stale bookmarks).
 */
const KioskGuestRouteRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const match = location.pathname.match(/^\/restaurants\/([^/]+)/);
    if (!match) return;
    if (!isRestaurantPathRedirectableToKiosk(location.pathname)) return;

    const appName = decodeURIComponent(match[1]);
    if (!shouldRedirectRestaurantPathToKiosk(appName)) return;

    navigate(mapRestaurantPathToKiosk(appName, `${location.pathname}${location.search}`), {
      replace: true,
    });
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default KioskGuestRouteRedirect;
